import { Checkbox, Form, Input } from 'antd';
import type { FormInstance } from 'antd';
import React, { FC } from 'react';

import styles from './Worksheet.module.scss';

type Props = {
  form: FormInstance;
};

const IndividualFields: FC<Props> = ({ form }) => {
  return (
    <div>
      <Form.Item
        name="indFamily"
        rules={[{ required: true, message: 'Обязательное поле' }]}
        className={styles['form-item']}
        label="Фамилия (на русском)"
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="indName"
        rules={[{ required: true, message: 'Обязательное поле' }]}
        className={styles['form-item']}
        label="Имя (на русском)"
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="indSurname"
        className={styles['form-item']}
        label="Отчество (на русском)"
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="indFamilyEn"
        rules={[{ required: true, message: 'Обязательное поле' }]}
        className={styles['form-item']}
        label="Фамилия (на англ.)"
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="indNameEn"
        rules={[{ required: true, message: 'Обязательное поле' }]}
        className={styles['form-item']}
        label="Имя (на англ.)"
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="indSurnameEn"
        className={styles['form-item']}
        label="Отчество (на англ.)"
      >
        <Input />
      </Form.Item>

      <Form.Item
        rules={[{ required: true, message: 'Обязательное поле' }]}
        name="identityDocument"
        className={styles['form-item']}
        label="Документ удостоверяющий личность (на русском)"
      >
        <Input />
      </Form.Item>

      <Form.Item
        rules={[{ required: true, message: 'Обязательное поле' }]}
        name="identityDocumentEn"
        className={styles['form-item']}
        label="Документ удостоверяющий личность (на англ.)"
      >
        <Input />
      </Form.Item>

      <Form.Item
        rules={[{ required: true, message: 'Обязательное поле' }]}
        name="inn"
        className={styles['form-item']}
        label="ИНН (Налоговый номер юридического лица в стране регистрации)"
      >
        <Input />
      </Form.Item>

      <Form.Item
        rules={[{ required: true, message: 'Обязательное поле' }]}
        name="addressRu"
        className={styles['form-item']}
        label="Адрес регистрации (на русском)"
      >
        <Input />
      </Form.Item>

      <Form.Item
        rules={[{ required: true, message: 'Обязательное поле' }]}
        className={styles['form-item']}
        name="addressEn"
        label="Адрес регистрации (на англ.)"
      >
        <Input />
      </Form.Item>

      <Form.Item
        rules={[{ required: true, message: 'Обязательное поле' }]}
        name="actualAddressRu"
        className={styles['form-item']}
        label="Адрес проживания (на русском)"
      >
        <Input />
      </Form.Item>

      <Form.Item
        rules={[{ required: true, message: 'Обязательное поле' }]}
        className={styles['form-item']}
        name="actualAddressEn"
        label="Адрес проживания (на англ.)"
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="eMailOrganization"
        rules={[{ required: true, message: 'Обязательное поле' }]}
        className={styles['form-item']}
        label="Адрес эл.почты физ.лица (для договора и официальной переписки)"
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="phone"
        rules={[{ required: true, message: 'Обязательное поле' }]}
        className={styles['form-item']}
        label="Контактный телефон ФЛ (для договора и звонков)"
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="publicOfficial"
        className={styles['form-item']}
        label="Является ли ПДЛ"
        valuePropName="checked"
      >
        <Checkbox
          style={{ transform: 'scale(1.5)', fontSize: '16px' }}
          defaultChecked={form.getFieldInstance('publicOfficial')}
        />
      </Form.Item>
    </div>
  );
};

export default IndividualFields;
